/**
 * Génère un code d'entité (client, fournisseur, article, code-barre)
 * à partir d'un préfixe, d'une valeur numérique et d'une longueur de padding.
 *
 * Exemples :
 *   generateEntityCode('CLI', 1, 4)  → "CLI0001"
 *   generateEntityCode('FRN', 42, 4) → "FRN0042"
 *   generateEntityCode('', 1, 8)     → "00000001"   (code-barre sans préfixe)
 *
 * Note : l'incrémentation atomique est gérée côté base de données
 * (RPC consume_entity_code). Cette fonction ne fait que formater.
 */
export function generateEntityCode(
  prefix: string,
  value: number,
  padding = 4,
): string {
  const safePadding = padding > 0 ? padding : 1;
  const padded = String(Math.max(0, Math.trunc(value))).padStart(safePadding, '0');
  return `${prefix}${padded}`;
}
